import React from 'react';
import Button from 'components/Button';
import {VoiceControl} from 'components/ContentPagesComponents/VoiceAgent/VoiceControl';
import {Dots} from 'components/ContentPagesComponents/VoiceAgent/VoiceControl/Preparing/Dots';
import {useToggle} from 'hooks/useToggle';

import * as styles from './styles.module.scss';

export const Consultant = () => {
	const {open, toggle} = useToggle(false);
	return (
		<div className={styles.consultant}>
			<div className={styles.text}>
				<div className={styles.optional}>
					<span>You can ask ...</span>
					<ul>
						<li>Give me quick overview</li>
						<li>Are my numbers good?</li>
						<li>What do I do next?</li>
					</ul>
					<div>
						Speak naturally! More context and
						specifics helps us provide better answers.
					</div>
				</div>
				<div>
					<div>
						Conversations are recorded for quality.
						Consent by clicking <strong>Explain</strong>.
					</div>
				</div>
			</div>
			<div className={styles.voice}>
				{open ? (
					<VoiceControl
						onClose={toggle}
						onReport={() => {}}
					/>
				) : (
					<div className={styles.initial}>
						<Dots speed={0} />
						<Button variant='light' onClick={toggle}>
							Explain my results
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};
